import React from 'react';
import { SearchIcon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { ChevronHeading } from '../components/ChevronHeading';
import { useSession } from '../contexts/SessionContext';
import { images } from '../data/site';
export function Home() {
  const {
    isLoggedIn
  } = useSession();
  return <PageShell championBannerLayout="contained" data-id="element-290" data-mp="2x56c2p6c6u9a">
      <section className="relative h-[420px] overflow-hidden md:h-[500px]" data-id="element-291" data-mp="1zi7co6o9f87p">
        <img src={images.hero} alt="Youth volleyball player reaching for the ball at the net" className="absolute inset-0 h-full w-full object-cover" data-id="element-292" data-mp="1zkaahcvnm5mz" />
        <div className="absolute inset-0 bg-black/30" aria-hidden data-id="element-293" data-mp="29f27aehewogp" />
        <h1 className="relative z-10 flex h-full items-center justify-center px-6 pb-20 text-center font-condensed text-5xl font-extrabold italic text-white md:text-7xl" data-id="element-294" data-mp="2dhgsv6cgu2bo">
          The Way Youth Sports Should Be®
        </h1>
        <svg className="absolute bottom-0 left-0 h-[150px] w-full" viewBox="0 0 1600 150" preserveAspectRatio="none" aria-hidden data-id="element-295" data-mp="3ovuavukjfnjs">
          <path d="M0,10 Q800,290 1600,10 V150 H0 Z" fill="#38B1F2" data-id="element-296" data-mp="30w0582vzto53" />
          <path d="M0,50 Q800,250 1600,50 V150 H0 Z" fill="#EE2B24" data-id="element-297" data-mp="2vyq964e3me8a" />
          <path d="M0,90 Q800,210 1600,90 V150 H0 Z" fill="#2B33EE" data-id="element-298" data-mp="2qybzkhwumw85" />
        </svg>
      </section>

      <section className="px-6 py-14 text-center" data-id="element-299" data-mp="2mxa6kitizgem">
        <ChevronHeading data-id="element-300" data-mp="2mwh0zl6aywy2">Find a program near you</ChevronHeading>
        <form className="mx-auto mt-8 flex max-w-md" onSubmit={e => e.preventDefault()} role="search" data-id="element-301" data-mp="2hy71iydjpa6n">
          <label htmlFor="home-zip" className="sr-only" data-id="element-302" data-mp="2d65txprbo7my">ZIP Code</label>
          <input id="home-zip" defaultValue={isLoggedIn ? '33023' : ''} placeholder="ZIP Code" className="h-12 min-w-0 flex-1 rounded-l border-2 border-gray-300 px-3 text-lg outline-none focus:border-brand-sky" data-id="element-303" data-mp="287ujpdx47v47" />
          <button type="submit" className="flex items-center gap-2 whitespace-nowrap rounded-r bg-brand-red px-5 text-lg font-semibold text-white transition-colors duration-150 hover:bg-brand-red-dark" data-id="element-304" data-mp="1z9iikhymhexi">
            <SearchIcon className="h-4 w-4" aria-hidden data-id="element-305" data-mp="1kn3eij86q147" /> Find Programs
          </button>
        </form>
      </section>
    </PageShell>;
}